export default "__VITE_ASSET__BzVfbLUn__"